// ** React Imports
import { useState, useEffect } from "react";
import { useAuth } from "src/hooks/useAuth";

// ** Icons
import EmailOutline from "mdi-material-ui/EmailOutline";
import ShieldKeyOutline from "mdi-material-ui/ShieldKeyOutline";

// ** Auth UI
import AuthShell from "src/views/pages/auth/AuthShell";
import OTPContent from "./OPTContent";
import RequestOTP from "./RequestOTP";
import ModalMessage from "./ModalMessage";
import Spinner from "src/@core/components/spinner";

const OTPPage = () => {
  const auth = useAuth();
  const [otpData, setOtpData] = useState({ otp: "", email: "" });
  const [step, setStep] = useState(0);
  const [messageModal, setMessageModal] = useState({ visible: false, title: "", description: "" });

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    let emailAddress = query.get("c");

    if (emailAddress) {
      try {
        emailAddress = window.atob(emailAddress);
        setOtpData({ otp: "", email: emailAddress });

        // remove "c" parameter from URL
        const url = new URL(window.location.href);
        url.searchParams.delete("c");
        window.history.replaceState({}, "", url);

        // Error handling
      } catch (e) {
        console.error("Error decoding email address:", e);
      }
    }

    setStep(1);
  }, []);

  const onSubmit = (data) => {
    const { otp, email } = data;

    auth.otpLogin({ otp, email: email }, (a) => {
      parseLoginError(a?.response?.data?.reason);
    });
  };

  const parseLoginError = (reason) => {
    switch (reason) {
      case "record_not_found":
        setMessageModal({
          visible: true,
          title: "Registo não encontrado",
          description: "Não foi possível encontrar o registo associado a este endereço de e-mail.",
        });
        break;

      case "otp_expired":
        setMessageModal({
          visible: true,
          title: "Código expirado",
          description: "O código de verificação expirou. Solicita um novo código.",
        });
        break;

      case "otp_does_not_match":
        setMessageModal({
          visible: true,
          title: "Código incorreto",
          description: "O código de verificação introduzido está incorreto. Por favor, tenta novamente.",
        });
        break;

      case "user_blocked":
        setMessageModal({
          visible: true,
          title: "Conta bloqueada",
          description: "A tua conta foi bloqueada. Por favor, contacta o suporte através do e-mail suporte@salespark.io.",
        });
        break;
      case "user_not_active":
        setMessageModal({
          visible: true,
          title: "Utilizador inativo",
          description: "O teu utilizador está inativo. Por favor, contacta o suporte através do e-mail suporte@salespark.io.",
        });
        break;
      default:
        setMessageModal({
          visible: true,
          title: "Erro",
          description:
            "Ocorreu um erro ao tentar fazer login. Por favor, tenta novamente, ou contacta o suporte através do e-mail suporte@salespark.io se o problema persistir.",
        });
        break;
    }
  };

  const isVerify = step === 2;
  const subtitle = isVerify
    ? "Introduz o código de 4 dígitos para entrares."
    : otpData?.email
    ? "Confirma o teu e-mail e enviamos-te um código de acesso."
    : "Indica o teu e-mail e enviamos-te um código de acesso.";

  return (
    <>
      <AuthShell
        icon={isVerify ? <ShieldKeyOutline /> : <EmailOutline />}
        eyebrow="Código de acesso"
        title={isVerify ? "Verifica o teu e-mail" : "Entrar com código"}
        subtitle={subtitle}
      >
        {step === 0 && <Spinner />}
        {step === 1 && (
          <RequestOTP
            otp={otpData}
            setOtp={setOtpData}
            onSuccess={() => {
              if (!otpData?.email) return;
              setStep(2);
            }}
          />
        )}
        {step === 2 && (
          <OTPContent
            otp={otpData}
            setOtp={setOtpData}
            handleSubmit={() => {
              onSubmit({ otp: otpData.otp, email: otpData.email });
            }}
            requestNewOTP={() => setStep(1)}
          />
        )}
      </AuthShell>
      <ModalMessage
        visible={messageModal.visible}
        close={() => setMessageModal({ visible: false })}
        title={messageModal.title}
        description={messageModal.description}
      />
    </>
  );
};

export default OTPPage;
